<template>
  <div class="FlechaSubir">
    <a id="BackTop" class="scroll-to-top btnScrollTop shadow-lg">
      <center>
        <ion-icon
          name="arrow-up"
          class="mt-2"
          style="font-size: 15pt"
        ></ion-icon>
      </center>
    </a>
  </div>
</template>

<script>
export default {
  name: "FlechaSubir",

  mounted() {
    $(window).scroll(function () {
      if ($(this).scrollTop() >= 350) {
        $("#BackTop").fadeIn(200);
      } else {
        $("#BackTop").fadeOut(200);
      }
    });
    $("#BackTop").click(function () {
      $("body,html").animate(
        {
          scrollTop: 0,
        },
        500
      );
    });
  },
};
</script>

<style scoped>
.btnScrollTop {
  border-radius: 20px !important;
}
#BackTop {
  display: none;
  position: fixed;
  bottom: 60px;
  right: 45px;
  z-index: 99;
  font-size: 18px;
  border: none;
  outline: none;
  background-color: #6127ff;
  color: white;
  cursor: pointer;
  width: 40px;
  height: 40px;
  border-radius: 4px;
}
#BackTop:hover {
  background-color: white;
  color: #6127ff;
  border: 1px solid #6127ff !important;
}
@media screen and (max-width: 767px) {
  #BackTop {
    display: none;
    position: fixed;
    bottom: 50px;
    right: 1px;
    z-index: 99;
    font-size: 18px;
    border: none;
    outline: none;
    background-color: #6127ff;
    color: white;
    cursor: pointer;
    width: 40px;
    height: 40px;
    border-radius: 4px;
  }
}
</style>
